"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param firestore
 * @param doctorUid uid del doctor
 * @returns doctor de providers/uid
 */
function useDoctor(firestore, doctorUid) {
    const appointmentRef = (0, firestore_2.doc)(firestore, `providers/${doctorUid}`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "provider",
        path: `providers/${doctorUid}`
    }, [doctorUid]), appointmentRef);
}
exports.default = useDoctor;
